/**
 * Referral code validation
 * Based on Move contract rules: alphanumeric, 1-32 characters
 */
export const REFERRAL_CODE_MAX_LENGTH = 32;
export const REFERRAL_CODE_REGEX = new RegExp(`^[a-zA-Z0-9]{1,${REFERRAL_CODE_MAX_LENGTH}}$`);

export function isValidReferralCode(code: string): boolean {
  return REFERRAL_CODE_REGEX.test(code);
}
